// Content Security Policy — dedicated Route Policies page.
// See Config.js — this is a thin wrapper that gates the shared
// CspConfig implementation to the "routes" section only.

import React from "react";
import CspConfig from "./Config";

export default function CspRoutes() {
  return <CspConfig section="routes" />;
}
